import HeaderMobile from './component'

export default HeaderMobile
